/**
 * Запрос конфигурации
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function fetchConfig(options) {
    return await fetch('/data/config.json', options)
        .catch(console.error)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText)
            }
            return response.json();
        });
}

/**
 * Запрос адресов точек реализации
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function fetchAddresses(options) {
    return await fetch('/data/addresses.json', options)
        .catch(console.error)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText)
            }
            return response.json();
        });
}

/**
 * Запрос услуг
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function fetchItems(options) {
    return await fetch('/data/items.json', options)
        .catch(console.error)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        });
}

/**
 * Запрос вариантов услуги
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function fetchVariations(options) {
    return await fetch('/data/variations.json', options)
        .catch(console.error)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        });
}

/**
 * Запрос персонала
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function fetchPersons(options) {
    return fetch('/data/persons.json', options)
        .catch(console.error)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        });
}

/**
 * Запрос дат с событиями
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function fetchDates(options) {
    return await fetch('/data/dates.json', options)
        .catch(console.error)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        });
}

/**
 * Запрос событий
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function fetchDefaultEvents(options) {
    const {epochTimestamp} = options;
    return await fetch(`/data/default_events/${epochTimestamp}.json`, options)
        .catch(console.error)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        });
}

/**
 * Запрос группированных по персоне событий
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function fetchGroupedEvents(options) {
    const {epochTimestamp} = options;
    return await fetch(`/data/grouped_events/${epochTimestamp}.json`, options)
        .catch(console.error)
        .then(response => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        });
}

/**
 * Запрос данных пользователя
 * (вдруг нужно будет выводить данные пользователя для аутентификации)
 * @param options
 * @returns {Promise<Response|void>}
 */
// export async function fetchUserByPhone({phone}) {
//     console.log(`[api] Запрос пользователя для "${phone}"`)
//     return new Promise((resolve) => setTimeout(resolve({
//         id: 850021,
//         fname: 'Вася',
//         lname: 'Пупкин',
//         uname: null,
//         email: null,
//     }), 1000))
// }

/**
 * Запрос кода подтверждения
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function requestSMSCode({phone}) {
    console.log(`[api] Запрос кода для "${phone}"`)
    // fixme: убрать рандомайзер, он только для теста
    const response = Math.random() < 0.5; // Тестовый ответ

    return new Promise((resolve) => setTimeout(resolve({
        status: response, //true or false
        error_message: response === false ? 'Произошла ошибка. Повторите запрос кода снова' : ''
    }), 1000));
}

/**
 * Проверка кода подтверждения
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function checkSMSCode({code, phone}) {
    console.log(`[api] Проверка кода "${code}" для "${phone}"`)
    // fixme: убрать const и рандомайзер, они только для теста
    const response = true; // Тестовый ответ
    const isSuccess = Math.random() < 0.5; //Корректность кода

    return new Promise((resolve) => setTimeout(() => resolve({
        status: response, //true or false
        is_success: isSuccess, //true or false
        error_message: isSuccess === false ? 'Введен некорректный код' : ''
    }), 500));
}

/**
 * Запрос на бронирование
 * @param options
 * @returns {Promise<Response|void>}
 */
export async function bookEvents(/*options*/) {
    return new Promise((resolve) => setTimeout(resolve, 1000))
}
